<template>
  <div class="vert-offset-top-2">
    <div class="col s12">
      <div class="center padding-bottom-1 ">
        <h6 class=" vert-offset-top-half yellow-text text-darken-3 font-bold">
          Welcome To The Tebelopele Client Booking Systems
        </h6>
      </div>
      <carousel-component class="col s10 l7 offset-l4 ">
        <a class="carousel-item ">
          <img
            src="65074706_2464764816950448_3669409892067704832_o.jpg"
            alt="booking"
            style="height: 20em;"
          />
        </a>
        <a class="carousel-item">
          <img src="slideshow-a01.jpg" alt="1" />
        </a>
        <a class="carousel-item">
          <img src="slideshow-a02.jpg" alt="2" />
        </a>
        <a class="carousel-item">
          <img src="slideshow-a03.jpg" alt="3" />
        </a>
      </carousel-component>
    </div>
    <div class="card ">
      <div class="card-content col s12  ">
        <div class="col s12 row">
          <p
            class="col s9 l6 offset-l3 padding-top-half padding-bottom-half left-align font-14"
          >
            Tebelopele is a non-profit health and wellness organization
            dedicated to protecting and improving the lives of communities
            across Botswana for over 20 years.
          </p>
          <p
            class="col s7 l6 offset-l3 padding-top-1 padding-bottom-half left-align font-14"
          >
            Tebelopele facilities are situated in 18 locations serving residents
            in rural, urban and town areas. In August 2018, Tebelopele,
            Botswana’s first and largest non-profit HIV Testing and Counseling
            service provider, expanded its service offerings from voluntary
            counseling and testing to integrated HIV-SRH services which
            includes: HIV and STI screening and treatment, TB screening, TB
            Preventative Therapy, family planning, Pre Exposure Prophylaxis
            (PrEP) and Post Exposure Prophylaxis (PEP) in 5 of its 18 locations
            (Gaborone, Maun, Kweneng East, Palapye and Francistown) in
            collaboration with the Ministry of Health and Wellness,
            PEPFAR/USAID/FHI 360 and ACHAP Global Fund.
          </p>
        </div>
        <div class="col s8 vert-offset-top-2">
          <a
            @click="goto"
            class="btn btn-small orange darken-1  white-text col s8 offset-s2  padding-bottom-1"
          >
            Click here to book with us for services
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import CarouselComponent from "../components/materiallize/CarouselComponent";
export default {
  name: "Home",
  components: {
    CarouselComponent
  },
  methods: {
    goto() {
      this.$store.dispatch("START_PROCESSING");

      this.$router.push("/selectcenter");
      this.$store.dispatch("STOP_PROCESSING");
    }
  },
  computed: {},
  mounted() {}
};
</script>
<style>
.carousel .carousel-item {
}
</style>
